export const BROWSER_VARIABLE = {
    COOKIE: 'cookie',
    LOCAL_STORAGE: 'localStorage',
    JS_VARIABLE: 'jsVariable',
    CSS_PATH: 'cssPath',
    URL_QUERY: 'urlQuery',
    URL_REGEX: 'urlRegex',
    SALES_FORCE: 'salesForce',
    SUCCESS_FACTORS: 'successFactors',
    NOT_SET: 'notSet',
    USER_PROVIDED: 'userProvided',
} as const;

export const APPLICATION_SCRIPT_VERSION = {
    STABLE: 'stable',
    CANARY: 'canary',
    HOTTEST: 'hottest',
} as const;

export const APPLICATION_PROVISIONING_STRATEGY = {
    UNITED: 'united',
    UNIQUE: 'unique',
} as const;

export const GUIDANCE_CONTROL_ATTACHMENT = {
    STEP: 'step',
    CONTEXT_HELP: 'contextHelp',
    CONTEXT_HELP_AND_STEP: 'contextHelpAndStep',
    LAUNCHER: 'launcher',
    LAUNCHER_AND_STEP: 'launcherAndStep',
    EVERYWHERE: 'everywhere',
} as const;

export const GUIDANCE_CONTROL_PERSISTENCE = {
    BROWSER_RESTART: 'browserRestart',
    CURRENT_SESSION: 'currentSession',
} as const;

export const JOURNEY_TRACKER_VISIBLE_ACTIONS = {
    NO_ACTION: 'noAction',
    LEAVE_TRACKER_VISIBLE: 'leaveTrackerVisible',
} as const;

export const JOURNEY_TRACKER_AFTER_FINISH_TOUR_ACTIONS = {
    NO_ACTION: 'noAction',
    OPEN_CONTEXT_HELP: 'openContextHelp',
} as const;

export const APPLICATION_SCROLLING_BEHAVIOR_MODE = {
    NATIVE: 'native',
    LIBRARY: 'library',
} as const;

export const APPLICATION_SCROLLING_BEHAVIOR_WHEN = {
    ALWAYS: 'always',
    IF_NEEDED: 'ifNeeded',
} as const;
